module.exports = __webpack_public_path__ + "static/media/38-6.1c22e21f.mp3";